import { FBTrackingEvent } from '../../Utility/Tracking/FBTrackingEvent';

export enum ProductID {
    ID_007_COINS_2k = '007',
    ID_008_COINS_6k = '008',
    ID_009_COINS_22k = '009',
    ID_010_COINS_100k = '010',
    ID_011_SPECIAL_OFFER = '011',
    ID_012_SPECIAL_JOKER = '012',
}

export type ProductValues = {
    coins?: number;
    lives?: number;
    boosterTNT?: number;
    boosterJokers?: number;
    trackingStart: FBTrackingEvent;
    trackingSuccess: FBTrackingEvent;
    trackingFail: FBTrackingEvent;
};

export const ProductValueMap: { [key in ProductID]: ProductValues } = {
    '007': {
        coins: 2000,
        trackingStart: FBTrackingEvent.Product007_Start,
        trackingSuccess: FBTrackingEvent.Product007_Success,
        trackingFail: FBTrackingEvent.Product007_Fail,
    },
    '008': {
        coins: 6000,
        trackingStart: FBTrackingEvent.Product008_Start,
        trackingSuccess: FBTrackingEvent.Product008_Success,
        trackingFail: FBTrackingEvent.Product008_Fail,
    },
    '009': {
        coins: 22000,
        trackingStart: FBTrackingEvent.Product009_Start,
        trackingSuccess: FBTrackingEvent.Product009_Success,
        trackingFail: FBTrackingEvent.Product009_Fail,
    },
    '010': {
        coins: 100000,
        trackingStart: FBTrackingEvent.Product010_Start,
        trackingSuccess: FBTrackingEvent.Product010_Success,
        trackingFail: FBTrackingEvent.Product010_Fail,
    },
    '011': {
        coins: 10000,
        lives: 7,
        boosterJokers: 3,
        boosterTNT: 3,
        trackingStart: FBTrackingEvent.Product011_Start,
        trackingSuccess: FBTrackingEvent.Product011_Success,
        trackingFail: FBTrackingEvent.Product011_Fail,
    },
    '012': {
        coins: 30000,
        boosterJokers: 15,
        trackingStart: FBTrackingEvent.Product012_Start,
        trackingSuccess: FBTrackingEvent.Product012_Success,
        trackingFail: FBTrackingEvent.Product012_Fail,
    },
};

export enum PurchaseStatus {
    START = 'Start',
    SUCCESS = 'Success',
    FAIL = 'Fail',
}

export function isProduct(ID: string): ID is ProductID {
    if (ID === ProductID.ID_007_COINS_2k) return true;
    if (ID === ProductID.ID_008_COINS_6k) return true;
    if (ID === ProductID.ID_009_COINS_22k) return true;
    if (ID === ProductID.ID_010_COINS_100k) return true;
    if (ID === ProductID.ID_011_SPECIAL_OFFER) return true;
    if (ID === ProductID.ID_012_SPECIAL_JOKER) return true;
    return false;
}
